//#region src/motion/transitions.ts
var e = [
	.22,
	1,
	.36,
	1
], t = [
	.76,
	0,
	.24,
	1
], n = {
	fast: .18,
	base: .32,
	slow: .55
}, r = .055, i = 10, a = {
	duration: n.slow,
	ease: e
}, o = {
	duration: n.fast,
	ease: e
}, s = {
	type: "spring",
	damping: 24,
	stiffness: 180
}, c = {
	hidden: {
		opacity: 0,
		y: 10
	},
	show: {
		opacity: 1,
		y: 0,
		transition: a
	}
}, l = (e = r, t = 0) => ({
	hidden: {},
	show: { transition: {
		staggerChildren: e,
		delayChildren: t
	} }
});
//#endregion
export { a as dampened, n as durations, t as easeInOutQuart, e as easeOutQuart, s as gentleSpring, i as revealDistance, c as revealItem, o as snappy, l as staggerContainer, r as staggerStep };

//# sourceMappingURL=transitions.js.map